// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2S1Nt","title":"Header_title__3_dCo","side":"Header_side__1q0pc"};